import { useState } from "react";
import Overlay from "../../../UI/Overlay";
import css from "./Pictures.module.css";
import Pictures from "./Pictures";

const ContainerPictures = (props) => {
	const [modal, setModal] = useState(false);

	const toggleModal = () => {
		const responsive = document.body.clientWidth;
		if (responsive >= 768) {
			setModal((o) => !o);
		}
	};

	return (
		<div className={css.container}>
			{modal && Overlay("black", 0.7, 22, toggleModal)}
			<Pictures product={props.product} setModal={toggleModal} />
			{modal && <Pictures product={props.product} setModal={toggleModal} fixed={"fixed"} />}
		</div>
	);
};

export default ContainerPictures;
